module.exports = __webpack_public_path__ + "media/images/flags/32/Slovakia-3bd5da238d9aa18cbf476afac5e037d4.png";